import styled from "styled-components";

export const Ka107Wrapper = styled.div``